import * as React from "react";
import Button from "@mui/material/Button";

export default function AdminButton({ name,className ,size, style, type,variant="contained", disabled, fullWidth ,...otherProps}) {
 
  return (
   
    <Button
      sx={style}
      variant={variant}
      size={size}
      type={type}
      disabled={disabled}
      fullWidth={fullWidth}
      className={className}
      {...otherProps}

    >
      {name}
    </Button>
  );
}
